import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';

export const getStudyMarkingsApi = createAsyncThunk(
  REPORTS.GET_STUDY_MARKINGS,
  async (_, { rejectWithValue }) => {
    try {
      const token = getToken();
      const hospitalId = localStorage.getItem('hospitalId') || sessionStorage.getItem('hospitalId');

      if (!hospitalId) {
        throw new Error('Hospital ID not found in storage');
      }

      const response = await fetch(`${REPORTS.GET_STUDY_MARKINGS}?hospitalId=${hospitalId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.msg || 'Get Report Templates failed');
      }

      const result = await response.json();
      return result;
    } catch (error) {
      return rejectWithValue(error.message || 'An error occurred');
    }
  }
);
